<template>
	<!--车辆轨迹页面_左栏详细信息开始-->
	<div class="menu-bar-vertical02 left_car_info" :class="{'opac': isPlaying}">
		<dl>
			<dt><span>行车时长：{{carPassedTimeStr}}</span><span>平均时速：{{traceRecord.avgSpeed}}km （畅通时：{{traceRecord.highestSpeed}}km  拥堵时：{{traceRecord.lowestSpeed}}km）</span><span>行驶里程：{{traceRecord.mileage}}km</span></dt>
			<dd>
				当前地址：{{ads}}
			</dd>
		</dl>
	</div>
	<!--车辆轨迹页面_左栏详细信息结束-->
</template>

<script>
	import {mapState} from 'vuex'
	export default{
		data(){
			return {
				ads:'',
				carPassedTimeStr: "text"
			}
		},
		computed:mapState({
			trackInfoList:state => state.vehicle.trackInfoList,
			momentTrack:state => state.vehicle.momentTrack,
			traceRecord:state=>state.vehicle.traceRecord,
			isPlaying:state => state.vehicle.isPlaying
		}),
		watch:{	
			momentTrack:function(val){
				if(val === undefined){
					this.ads = this.trackInfoList[0].address
				}else{
					this.ads = val.address	
				}
			}
		},
		mounted(){
			this.ads = this.trackInfoList[0].address;
			const val = this.traceRecord;
			if(!val.carPassedTime){
				return;
			}
			console.log(val.carPassedTime);
			if(val.carPassedTime < 60){
				this.carPassedTimeStr = val.carPassedTime + "分钟";
			} else if(val.carPassedTime < 60 * 24) {
				let mins = val.carPassedTime % 60;
				let hours = (val.carPassedTime - mins)/60;
				this.carPassedTimeStr = hours + "小时" + mins + "分钟";
			} else {
				let mins = val.carPassedTime % 60;
				let hours = ((val.carPassedTime - mins)/60) % 24;
				let days = (((val.carPassedTime - mins)/60) - hours) / 24;
				this.carPassedTimeStr = days + "天" + hours + "小时" + mins + "分钟";
			}
		}
	}
</script>
<style>
.opac {
	opacity: 0.7;
}
</style>


// WEBPACK FOOTER //
// VehicleInfo.vue?18739c39